import { postBodyRejectOrAcceptParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/postBodyAcceptOrRejectRecievedImages/postBodyAcceptOrRejectRecievedImages.type';
import { postBodyAcceptOrRejectRecievedImagesFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/postBodyAcceptOrRejectRecievedImages/postBodyAcceptOrRejectRecievedImagesFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const postBodyAcceptOrRejectRecievedImagesOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  postBodyRejectOrAcceptParamsType
> => ({
  mutationKey: ['POST_BODY_ACCEPT_OR_REJECT_RECIEVED_IMAGES_OPTIONS'],
  mutationFn: ({ data, id }) =>
    postBodyAcceptOrRejectRecievedImagesFunction({ id, data }),
});
